import { render, staticRenderFns } from "./EntradasVendidasComponent.vue?vue&type=template&id=6c9953c1"
import script from "./EntradasVendidasComponent.vue?vue&type=script&lang=js"
export * from "./EntradasVendidasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports